import { motion } from 'framer-motion';

const GRAIN = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='220' height='220'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")";

const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  left: (i * 53) % 100, top: (i * 37 + 11) % 100, size: 2 + (i % 3), dur: 18 + (i % 7) * 3, delay: -(i * 1.7),
}));

export function Background({ dark = 0 }) {
  return (
    <div className="pk-bg" aria-hidden>
      <div className="pk-bg-gradient" />
      <div className="pk-bg-glow pk-bg-glow-a" />
      <div className="pk-bg-glow pk-bg-glow-b" />
      <div className="pk-bg-light" />
      <div className="pk-bg-particles">
        {PARTICLES.map((p, i) => (
          <span key={i} style={{ left: `${p.left}%`, top: `${p.top}%`, width: p.size, height: p.size, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s` }} />
        ))}
      </div>
      <div className="pk-bg-grain" style={{ backgroundImage: GRAIN }} />
      <motion.div className="pk-bg-dark" initial={false} animate={{ opacity: dark }} transition={{ duration: 1.4, ease: 'easeInOut' }} />
    </div>
  );
}
